// extracted by mini-css-extract-plugin
module.exports = {"tabs":"EditStore_tabs__2dW8F"};